export default "__VITE_ASSET__CB9Ar$rJ__"